export default __webpack_public_path__ + "static/media/AyoJogja.f8a183dd.png";